import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import cn from 'classnames';

import {
  TableTitle,
  ExportButton,
  LimitPaginationButton,
  PaginationGroup,
  EmptyState,
  FilterButton,
  SelectDropDown,
  DatePicker,
  ClearButton,
  Loading
} from '../../common/Elements/Elements';
import ArrActivityTable from './ArrActivityTable/ArrActivityTable';

import { validationNumber } from 'utils/validation';
import { exportConfig } from './helpers/configurates';
import { postRequest } from 'utils/requests';
import { initialTableShow } from 'utils/settings';
import { createSaveList, createReqBody } from './helpers/helpers';

import classes from './ArrActivity.module.scss';

const ArrActivity = ({ customerId }) => {
  const [arrData, setArrData] = useState([]);
  const [arrFilters, setArrFilters] = useState([]);

  const [fromTo, setFromTo] = useState({ arrFrom: '', arrTo: '' });
  const [date, setDate] = useState({ startDate: null, endDate: null });
  const [type, setType] = useState([]);
  const [person, setPerson] = useState([]);

  const [currentPage, setCurrentPage] = useState(initialTableShow.currentPage);
  const [itemsPerPage, setItemsPerPage] = useState(
    initialTableShow.itemsPerPage
  );
  const [fieldName, setFieldName] = useState('createdDate');
  const [direction, setDirection] = useState(initialTableShow.direction);
  const [filterButton, setFilterButton] = useState(false);
  const [reset, setReset] = useState(true);

  const [loader, setLoader] = useState(true);
  const [loaderTable, setLoaderTable] = useState(false);
  const [trigerUseEffect, setTrigerUseEffect] = useState(0);
  const [dataConection, setDataConection] = useState(false);
  const [trigerResetDatePicker, setTrigerResetDatePicker] = useState(false);

  const numberОfFilters = 3;

  const { t } = useTranslation(['activity']);

  const history = useHistory();
  const location = useLocation();

  exportConfig.exportName = `${customerId}_`;

  const resetCurentPage = () => {
    setCurrentPage(1);
  };

  const handleLimitChange = limit => {
    if (itemsPerPage === limit) {
      return;
    }
    resetCurentPage();
    setItemsPerPage(limit);
  };
  const handleFilterButton = () => {
    setFilterButton(!filterButton);
  };
  const handleSortable = field => () => {
    if (field === fieldName) {
      const directionTemp = direction * -1;
      setDirection(directionTemp);
    } else {
      setFieldName(field);
    }
  };

  const handleFromTo = e => {
    resetCurentPage();
    if (e.currentTarget.id) {
      setFromTo({
        ...fromTo,
        [`${e.currentTarget.id}From`]: '',
        [`${e.currentTarget.id}To`]: ''
      });
    } else {
      if (!validationNumber(e.target.value)) {
        setFromTo({
          ...fromTo,
          [e.target.name]: e.target.value
        });
      }
    }
  };
  const handleDateChange = date => {
    resetCurentPage();
    setDate(date);
  };
  const handleType = e => {
    resetCurentPage();
    setType(e);
  };

  useEffect(() => {
    let cancelled = false;
    postRequest('/customer/arractivity/list/filters', {
      customerId: customerId
    })
      .then(res => {
        !cancelled && setArrFilters(res.body);
      })
      .catch(err => {
        !cancelled && console.log(err);
      });
    return () => (cancelled = true);
  }, [customerId]);

  useEffect(() => {
    if (location.search) {
      const loadList = createSaveList(location);
      setFromTo(loadList.fromTo);
      setDate(loadList.date);
      setType(loadList.type);
      setPerson(loadList.person);
      setDirection(loadList.direction);
      setItemsPerPage(loadList.itemsPerPage);
      setCurrentPage(loadList.currentPage);
      setFieldName(loadList.fieldName);
    } else if (trigerUseEffect === 2) {
      history.replace(location.pathname);
      resetAllfilters();
    }
    setTrigerUseEffect(2);
    // eslint-disable-next-line
  }, []);

  const resetAllfilters = (clickButton = false) => {
    resetCurentPage();
    setDate({ startDate: null, endDate: null });
    setType([]);
    setPerson([]);
    !clickButton &&
      setFromTo({
        arrChangedFrom: '',
        arrChangedTo: ''
      });
    setItemsPerPage(initialTableShow.itemsPerPage);
    setFieldName('createdDate');
    setTrigerResetDatePicker(!trigerResetDatePicker);
    setDirection(initialTableShow.direction);
  };

  useEffect(() => {
    let cancelled = false;

    if (trigerUseEffect === 2) {
      setLoaderTable(true);

      const linkForRequest = `/customer/arractivity/list?page=${currentPage}&limit=${itemsPerPage}`;

      const REQ_BODY = createReqBody(
        date,
        type,
        person,
        fromTo,
        fieldName,
        direction,
        customerId
      );
      postRequest(linkForRequest, REQ_BODY)
        .then(res => {
          if (!cancelled) {
            setDataConection(true);
            setArrData(res.body);
            setLoader(false);
            setLoaderTable(false);
          }
        })
        .catch(err => {
          if (!cancelled) {
            setDataConection(false);
            setLoader(false);
            setLoaderTable(false);
            console.log(err);
          }
        });
      setReset(false);
      replaceHistory();
    }
    return () => (cancelled = true);
    // eslint-disable-next-line
  }, [
    date,
    type,
    person,
    fieldName,
    direction,
    currentPage,
    itemsPerPage,
    fromTo,
    trigerUseEffect,
    reset
  ]);

  const replaceHistory = () => {
    const query = `type=${type}&person=${person}&start=${date.startDate}&end=${
      date.endDate
    }&fromTo=${JSON.stringify(
      fromTo
    )}&direction=${direction}&itemsPerPage=${itemsPerPage}&currentPage=${currentPage}&fieldName=${fieldName}`;
    history.replace(`${location.pathname}?${query}`);
  };

  if (loader) {
    return <Loading />;
  }

  if (!dataConection) {
    return <EmptyState message="connect" />;
  }

  return (
    <>
      <TableTitle title={t('activity:platform:ACTIVITIES')} />
      <div className={classes.filters_main}>
        <FilterButton active={filterButton} onClick={handleFilterButton} />
      </div>
      <div
        className={cn(filterButton ? classes.filters : classes.filters_close)}
      >
        {!reset && (
          <>
            <SelectDropDown
              options={arrFilters.activityType}
              input={{ value: type, onChange: handleType }}
              label={t('activity:filters.ACTIVITY_TYPE')}
              multi
            />

            <DatePicker
              label={t('activity:filters.CREATE_DATE')}
              input={{
                value: date,
                onChange: handleDateChange
              }}
              trigerResetDatePicker={trigerResetDatePicker}
            />

            <ClearButton
              onClick={() => resetAllfilters(true)}
              numberОfFilters={numberОfFilters}
            />
          </>
        )}
      </div>

      <div
        className={cn(
          classes.actions,
          !filterButton && classes.actions_paddingWhenFilterClose
        )}
      >
        <TableTitle additional={arrData.totalRecords} />
        <div className={classes.actions_right}>
          <ExportButton
            exportConfig={exportConfig}
            isDisabled={!arrData.totalRecords}
          />
          <LimitPaginationButton
            currentLimit={itemsPerPage}
            onLimitChange={handleLimitChange}
          />
        </div>
      </div>

      <ArrActivityTable
        tableData={arrData.data}
        handleSortable={handleSortable}
        direction={direction}
        fieldName={fieldName}
        fromTo={fromTo}
        handleFromTo={handleFromTo}
        loader={loaderTable}
      />
      {arrData.data &&
        arrData.totalRecords > 9 &&
        loaderTable === false &&
        arrData.totalPages > 1 && (
          <PaginationGroup
            pageCount={arrData.totalPages}
            setPage={setCurrentPage}
            currentPage={currentPage}
            itemsTotal={arrData.totalRecords}
            itemsPerPage={itemsPerPage}
          />
        )}
    </>
  );
};

ArrActivity.propTypes = {
  customerId: PropTypes.string
};

export default ArrActivity;
